<template>
    <div class="auth-view">
        <div v-if="(type == 'oauth') && bus && currentBU">
            <form>
                <h3>Current BU</h3>
                <pre>{{currentBU}}</pre>
                <div class="form-group">
                    <label for="form_auth_type">Select BU</label>
                    <select
                        v-model="currentBU"
                        class="form-control"
                        v-on:change="switchBU"
                    >
                        <option 
                            v-for="bu in bus"
                            v-bind:key="bu.ID"
                            v-bind:value="bu"
                        >
                            {{bu.Name}}
                        </option>
                    </select>
                </div>
                <ProcessStatusView
                    v-if="processStatus.state != states.IDLE"
                    v-bind:processStatus="processStatus"
                />
            </form>
        </div>
        <div v-else>
            Loading BU info...
        </div>
    </div>
</template>
<script>
import ProcessStatusView, { ProcessStatus } from "@/components/ProcessStatusView";
import flywhweelSFMCUtilFactory from "@/services/flywheel-sfmc-util";

export default {
    name: 'AuthBUView',
    components: {
        ProcessStatusView
    },
    created: function() {
        this.$sfmc = flywhweelSFMCUtilFactory(this, "sfmc");
        this.$rest = flywhweelSFMCUtilFactory(this, "rest");
    },
    data: function() {
        var data = {
            bus: [],
            tokenContext: null,
            currentBU: null,
            states: {
                IDLE: "Idle",
                ERROR: "Error",
                SWITCHING: "Switching BU"
            }
        };
        data.processStatus = new ProcessStatus(data.states.IDLE);
        return data;
    },
    computed: {
        type: function() {
            return this.$sfmcAuth.type();
        }
    },
    mounted: function() {
        if (this.type == 'oauth') {
            this.getBU().then(
                () => this.getBUs()
            ).then(
                () => {
                    this.setCurrentBU();
                }
            );
        }
    },
    methods: {
        getBUs: function() {
            return this.$sfmc.apiCall(
                "retrieve",
                {
                    "object_type": "BusinessUnit",
                    "get_properties": [
                        "ID",
                        "Name"
                    ],
                    "include_client_id": false,
                    "query_all_accounts": true
                }
            ).then(
                (response) => {
                    this.bus = response.data;
                    return Promise.resolve(this.bus);
                }
            );
        },
        getBU: function() {
            return this.$rest.apiCall(
                {
                    "resource": "/platform/v1/tokenContext",
                    "method": "GET"
                }
            ).then(
                (response) => {
                    this.tokenContext = response.data;
                    return Promise.resolve(this.tokenContext);
                }
            );
        },
        setCurrentBU: function() {
            this.currentBU = this.bus.find((el) => {
                return el["ID"].toString() == this.tokenContext["organization"]["id"].toString();
            });
        },
        switchBU: function() {
            this.processStatus.reset();
            this.processStatus.state = this.states.SWITCHING;
            return this.$sfmcAuth.switchBU(
                this.currentBU["ID"]
            ).then(
                ()=> {
                    this.processStatus.state = this.states.IDLE;
                    return Promise.resolve()
                },
                (error) => {
                    this.processStatus.state = this.states.ERROR;
                    this.processStatus.error(
                        error.message,
                        error
                    )
                    //console.log(error);
                    return Promise.resolve();
                }
            ).then(
                () => this.getBU()
            ).then(
                () => {
                    this.setCurrentBU();
                }
            );
        }
    }
}
</script>